import { defineComponent as _defineComponent } from 'vue'
import { BankingScheme, FeePaymentType, FundingCharge, FeeChargeType, Beneficiary } from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { computed, ref, watch } from 'vue';
import { useAhTradesState } from '../..';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencyFundingFee',
  props: {
    paymentCurrency: null,
    bankingScheme: null,
    feePaymentType: null,
    chargeType: { default: FeeChargeType.SHA },
    beneficiary: { default: null },
    indexOfDetail: { default: 0 },
    small: { type: [String, Boolean], default: false }
  },
  setup(__props: any) {

const props = __props as { paymentCurrency: string, bankingScheme: BankingScheme, feePaymentType: FeePaymentType, chargeType: FeeChargeType, beneficiary: Beneficiary | null, indexOfDetail: number, small: string | boolean };



const requestManager = useRequestManager({ exposeToParent: false });

const tradeState = useAhTradesState();

const onBehalfOfClient = useOnBehalfOf();

const charge = ref<FundingCharge[] | null>(null);

const isClientUser = computed(() => tradeState.store.useAuthStore().isClientUser || onBehalfOfClient.value);

const clientId = computed(
  () => onBehalfOfClient.value?.id ?? tradeState.store.useAuthStore().loggedInIdentity?.client?.id ?? ''
);

const label = computed(() => (props.feePaymentType === FeePaymentType.RECEIPT ? 'Funding Fees' : 'Payment Fees'));

const isAllCurrencies = computed(() => {
  // if banking scheme is local allCurrencies will always be false
  // otherwise, we must check the chargeType:
  // SHA - allCurrencies is enabled
  // ACO - allCurrencies should be false/undefined
  if (props.bankingScheme === BankingScheme.SWIFT) {
    if (props.chargeType !== FeeChargeType.ACO) {
      return true;
    }
  }
  return false;
});

const countryCode = computed(() => {
  if (props.bankingScheme === BankingScheme.SWIFT && props.chargeType === FeeChargeType.ACO) {
    if (!props.beneficiary) {
      throw 'The beneficiary must be defined in ACO charges!';
    }
    return props.beneficiary!.bankCountry;
  }

  return undefined;
});

const fundingFeeRequest = computed(() => {
  const params = {
    bankingScheme: props.bankingScheme,
    type: props.feePaymentType,
    allCurrencies: isAllCurrencies.value,
    paymentCurrency: props.bankingScheme === BankingScheme.SWIFT ? undefined : props.paymentCurrency,
    countryCode: countryCode.value,
  };

  if (isClientUser.value) {
    return tradeState.services.fees.listClientFees({ ...params, clientId: clientId.value });
  }
  return tradeState.services.fees.listAHFees({
    ...params,
  });
});

function loadFee() {
  requestManager.manager.cancelAndNew('loadFee', fundingFeeRequest.value).subscribe((response) => {
    charge.value = response ?? null;
  });
}

watch(
  () => [props.bankingScheme, props.chargeType],
  () => {
    loadFee();
  },
  { immediate: true }
);

return { __sfc: true,props, requestManager, tradeState, onBehalfOfClient, charge, isClientUser, clientId, label, isAllCurrencies, countryCode, fundingFeeRequest, loadFee, formatCurrencyValue }
}

})